"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'OrderDetail',
  props: {
    orderData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      // 购买人信息数据
      buyerInfo: {
        orderNo: '',
        paymentStore: '',
        orderTime: '',
        paymentMethod: ''
      },
      // 包装信息数据
      packageInfo: {
        package: '',
        setMeal: '',
        setMealEdit: '',
        note: ''
      },
      // 收货人信息数据
      receiverInfo: {
        receiver: '',
        phone: '',
        address: ''
      },
      // 发货信息数据
      deliveryInfo: {
        deliveryOrder: '',
        deliveryTime: '',
        riderInfo: ''
      },
      // 费用信息数据
      costInfo: {
        productTotal: '',
        discount: '',
        deliveryFee: '',
        paidAmount: '',
        payableAmount: ''
      },
      // 操作信息数据
      operationInfo: {
        operationNote: ''
      },
      // 商品数据
      productData: [{
        name: '',
        image: '',
        marketPrice: '',
        unitPrice: '',
        discount: '',
        addPrice: '',
        quantity: '',
        method: '',
        refundStatus: ''
      }],
      // 优惠券数据
      couponData: [],
      // 美团优惠券数据meituanCouponData
      meituanCouponData: [{
        no: '',
        code: '',
        type: '',
        name: '',
        value: '',
        price: '',
        useCount: ''
      }],
      // 状态跟踪数据
      statusData: [{
        operator: '天财',
        operateTime: '2025-08-07 03:30:27',
        orderStatus: '已完结',
        paymentStatus: '已付款',
        deliveryStatus: '配送中',
        note: '退款'
      }, {
        operator: '买家',
        operateTime: '2025-08-07 03:30:27',
        orderStatus: '已完结',
        paymentStatus: '已付款',
        deliveryStatus: '配送中',
        note: '退款'
      }]
    };
  },
  methods: {
    // 全个订单
    handlePrevOrder: function handlePrevOrder() {
      this.$message.info('查看全个订单');
    },
    // 下个订单
    handleNextOrder: function handleNextOrder() {
      this.$message.info('查看下个订单');
    },
    // 移除操作
    handleRemove: function handleRemove() {
      var _this = this;
      this.$confirm('确认移除此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.$message.success('移除成功');
      });
    },
    // 生成菜蔬单
    handleGenerateMenu: function handleGenerateMenu() {
      this.$message.success('正在生成菜蔬单...');
    },
    // 备注
    handleAddNote: function handleAddNote() {
      this.$message.info('添加备注');
    }
  },
  mounted: function mounted() {
    console.log('订单详情 - 订单数据:', this.orderData);
  }
};